// Filters the grouped belt catalog by hiding cards (and empty style sections) in #product-grid.
class BeltFilter extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController()
    this.selected = { style: '', leather: '' }
    this.addEventListener('command', (event) => this.onCommand(event), { signal: this.abort.signal })
    // Old links to the Heritage view of All belts (?style=Heritage) now have their own collection.
    const params = new URLSearchParams(location.search)
    if (params.get('style') === 'Heritage') {
      location.replace('/collections/dress-casual-belts')
      return
    }
    // ?leather=Black (and so on) opens the page with that leather already chosen; the landing pages link here.
    const wanted = params.get('leather')
    if (wanted) {
      const buttons = [...this.querySelectorAll('[data-filter-group="leather"] button')]
      if (buttons.some((button) => button.value === wanted)) {
        this.selected.leather = wanted
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.value === wanted)))
      }
    }
    this.apply()
  }

  disconnectedCallback() {
    this.abort?.abort()
  }

  onCommand(event) {
    const kind = event.command.replace('--', '')
    if (!(kind in this.selected)) return
    // Clicking the active choice again unselects it and goes back to "all".
    const value = event.source.value
    this.selected[kind] = value && value === this.selected[kind] ? '' : value
    this.querySelectorAll(`[data-filter-group="${kind}"] button`).forEach((button) => {
      button.setAttribute('aria-pressed', String(button.value === this.selected[kind]))
    })
    this.apply()
  }

  apply() {
    const grid = document.getElementById('product-grid')
    if (!grid) return
    const { style, leather } = this.selected
    let shown = 0
    grid.querySelectorAll('li[data-style]').forEach((card) => {
      const match = (!style || card.dataset.style === style) && (!leather || card.dataset.leather === leather)
      card.hidden = !match
      if (match) shown += 1
    })
    let groupsShown = 0
    grid.querySelectorAll('[data-style-group]').forEach((group) => {
      group.hidden = !group.querySelector('li[data-style]:not([hidden])')
      if (!group.hidden) groupsShown += 1
    })
    // One leather across all styles: lay the style groups side by side, one column per group shown
    // (data-leather-view="2" or "3"; see templates/collection.liquid).
    const leatherView = leather && !style
    if (leatherView) grid.setAttribute('data-leather-view', String(groupsShown))
    else grid.removeAttribute('data-leather-view')
    // Fewer than five belts in a style: data-shown widens the cards so they fill the row.
    grid.querySelectorAll('[data-style-group] ul').forEach((list) => {
      const count = list.querySelectorAll(':scope > li[data-style]:not([hidden])').length
      if (!leatherView && count > 0 && count < 5) list.dataset.shown = String(count)
      else delete list.dataset.shown
    })
    const label = this.querySelector('[data-belt-count]')
    if (!label) return
    const key = shown === 0 ? 'none' : shown === 1 ? 'one' : 'other'
    const text = this.querySelector(`template[data-count-${key}]`).innerHTML.trim()
    label.textContent = text.replace('__count__', String(shown))
  }
}

customElements.define('belt-filter', BeltFilter)
